import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import ModalTriggerPromoPanelWrapper from './modal-trigger-promo-panel-wrapper';

class ModalTriggerPromoPanelComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    displayPromoBanner() {
        ReactDOM.render(
            <Fragment>
                <ModalTriggerPromoPanelWrapper
                    {...this.options}
                />
            </Fragment>,
            this.element
        );
    }

    render() {
        return this.displayPromoBanner();
    }
}
ModalTriggerPromoPanelComponent.propTypes = {
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    image: PropTypes.object,
    ctaButtonLabel: PropTypes.string,
    ctaButtonActionResource: PropTypes.string
};
export default ModalTriggerPromoPanelComponent;
